import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { MaxAppWidth } from '@ally/next-layout'
import { AriaLiveProvider } from '@ally/use-aria-live'

import { Auto } from '../components/auto/Auto'
import { CardWorks } from '../components/CardWorks'
import { Invest } from '../components/Invest'
import { OLA } from '../components/OLA'
import { Wealth } from '../components/Wealth'

export const Router: React.FC = () => {
  return (
    <MaxAppWidth py="md">
      <Switch>
        <Route path="/sso/auto/*">
          <Auto />
        </Route>
        <Route path="/sso/credit-card/*">
          <AriaLiveProvider>
            <CardWorks />
          </AriaLiveProvider>
        </Route>
        <Route path={['/sso/invest/*', '/ext-invest-live/*']}>
          <Invest />
        </Route>
        <Route path={['/sso/ola/*', '/ext-ola/*']}>
          <OLA />
        </Route>
        <Route path={['/sso/wealth/*', '/ext-wealth/*']}>
          <Wealth />
        </Route>
        <Route path="/sso/*">
          <Redirect to="/error/404" />
        </Route>
      </Switch>
    </MaxAppWidth>
  )
}

export default Router
